"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TherapyType;
(function (TherapyType) {
    TherapyType[TherapyType["Schwerkraft_PE"] = 0] = "Schwerkraft_PE";
    TherapyType[TherapyType["Pumpe_immobil_PE"] = 1] = "Pumpe_immobil_PE";
    TherapyType[TherapyType["Pumpe_mobil_PE"] = 2] = "Pumpe_mobil_PE";
    TherapyType[TherapyType["Schwerkraft_EE"] = 3] = "Schwerkraft_EE";
    TherapyType[TherapyType["Pumpe_immobil_EE"] = 4] = "Pumpe_immobil_EE";
    TherapyType[TherapyType["Pumpe_mobil_EE"] = 5] = "Pumpe_mobil_EE";
    TherapyType[TherapyType["Bolus"] = 6] = "Bolus";
    TherapyType[TherapyType["Trinknahrung"] = 7] = "Trinknahrung";
    TherapyType[TherapyType["Kolostoma"] = 8] = "Kolostoma";
    TherapyType[TherapyType["Urostoma"] = 9] = "Urostoma";
    TherapyType[TherapyType["Ileostoma"] = 10] = "Ileostoma";
    TherapyType[TherapyType["Tracheostoma_beatmet"] = 11] = "Tracheostoma_beatmet";
    TherapyType[TherapyType["Laryngektomie_beatmet"] = 12] = "Laryngektomie_beatmet";
    TherapyType[TherapyType["Inkontinenz_ableitend"] = 13] = "Inkontinenz_ableitend";
    TherapyType[TherapyType["Ulcus_cruris"] = 14] = "Ulcus_cruris";
    TherapyType[TherapyType["Dekubitus"] = 15] = "Dekubitus";
    TherapyType[TherapyType["Diabetisches_Fu\u00DFsyndrom"] = 16] = "Diabetisches_Fu\u00DFsyndrom";
    TherapyType[TherapyType["Ulzerierte_Tumore"] = 17] = "Ulzerierte_Tumore";
    TherapyType[TherapyType["Wundfisteln"] = 18] = "Wundfisteln";
    TherapyType[TherapyType["sonstige_chronische_Wunden"] = 19] = "sonstige_chronische_Wunden";
    TherapyType[TherapyType["Diabetes"] = 20] = "Diabetes";
    TherapyType[TherapyType["Pflegehilfsmittel"] = 21] = "Pflegehilfsmittel";
    TherapyType[TherapyType["Inkontinenz_aufsaugend"] = 22] = "Inkontinenz_aufsaugend";
    TherapyType[TherapyType["Compounding"] = 23] = "Compounding";
    TherapyType[TherapyType["Fistel"] = 24] = "Fistel";
    TherapyType[TherapyType["Antibiose"] = 25] = "Antibiose";
    TherapyType[TherapyType["Tracheostoma_unbeatmet"] = 26] = "Tracheostoma_unbeatmet";
    TherapyType[TherapyType["Laryngektomie_unbeatmet"] = 27] = "Laryngektomie_unbeatmet";
    TherapyType[TherapyType["Absaugung_au\u00DFerhalb_von_TS"] = 28] = "Absaugung_au\u00DFerhalb_von_TS";
    TherapyType[TherapyType["Beatmung"] = 29] = "Beatmung";
    TherapyType[TherapyType["sonstige_Wunden"] = 30] = "sonstige_Wunden";
    TherapyType[TherapyType["Schmerztherapie"] = 31] = "Schmerztherapie";
    TherapyType[TherapyType["Beatmung_invasiv"] = 32] = "Beatmung_invasiv";
    TherapyType[TherapyType["Beatmung_nicht_invasiv"] = 33] = "Beatmung_nicht_invasiv";
    TherapyType[TherapyType["Befeuchtung_aktiv"] = 34] = "Befeuchtung_aktiv";
    TherapyType[TherapyType["Befeuchtung_passiv"] = 35] = "Befeuchtung_passiv";
    TherapyType[TherapyType["Befeuchtung_integriert"] = 36] = "Befeuchtung_integriert";
    TherapyType[TherapyType["High_Flow"] = 37] = "High_Flow";
    TherapyType[TherapyType["CPAP"] = 38] = "CPAP";
    TherapyType[TherapyType["APAP"] = 39] = "APAP";
    TherapyType[TherapyType["Bilevel"] = 40] = "Bilevel";
    TherapyType[TherapyType["Bilevel_ST"] = 41] = "Bilevel_ST";
    TherapyType[TherapyType["Auto_Bilevel"] = 42] = "Auto_Bilevel";
    TherapyType[TherapyType["CS"] = 43] = "CS";
    TherapyType[TherapyType["Hustenhilfen"] = 44] = "Hustenhilfen";
    TherapyType[TherapyType["Sekretmobilisation"] = 45] = "Sekretmobilisation";
    TherapyType[TherapyType["Absaugung_oral"] = 46] = "Absaugung_oral";
    TherapyType[TherapyType["Absaugung_subglottisch"] = 47] = "Absaugung_subglottisch";
    TherapyType[TherapyType["Monitoring"] = 48] = "Monitoring";
    TherapyType[TherapyType["Pulsoximetrie"] = 49] = "Pulsoximetrie";
    TherapyType[TherapyType["Fingerpulsoximetrie"] = 50] = "Fingerpulsoximetrie";
    TherapyType[TherapyType["Kapnometer"] = 51] = "Kapnometer";
    TherapyType[TherapyType["Blutdruckmessgeraet"] = 52] = "Blutdruckmessgeraet";
    TherapyType[TherapyType["Sauerstoff_mobil"] = 53] = "Sauerstoff_mobil";
    TherapyType[TherapyType["Sauerstoff_fluessig"] = 54] = "Sauerstoff_fluessig";
    TherapyType[TherapyType["Inhalation"] = 55] = "Inhalation";
    TherapyType[TherapyType["Medikamentenvernebler"] = 56] = "Medikamentenvernebler";
    TherapyType[TherapyType["Ultraschallvernebler"] = 57] = "Ultraschallvernebler";
    TherapyType[TherapyType["PEP_Systeme"] = 58] = "PEP_Systeme";
    TherapyType[TherapyType["IPPB_Inhalation"] = 59] = "IPPB_Inhalation";
    TherapyType[TherapyType["Atemtherapie"] = 60] = "Atemtherapie";
    TherapyType[TherapyType["Sauerstoff_stationaer"] = 61] = "Sauerstoff_stationaer";
    TherapyType[TherapyType["Pumpe_mobil_ST"] = 62] = "Pumpe_mobil_ST";
    TherapyType[TherapyType["Anti_Dekubitussystem"] = 63] = "Anti_Dekubitussystem";
    TherapyType[TherapyType["Akute_Wunde"] = 64] = "Akute_Wunde";
    TherapyType[TherapyType["Transkutane_Harnleiterfistel"] = 65] = "Transkutane_Harnleiterfistel";
    TherapyType[TherapyType["MehrfachStoma"] = 66] = "MehrfachStoma";
    TherapyType[TherapyType["Pouch"] = 67] = "Pouch";
    TherapyType[TherapyType["Stomairrigation"] = 68] = "Stomairrigation";
    TherapyType[TherapyType["PE_Kinder"] = 69] = "PE_Kinder";
    TherapyType[TherapyType["EE_Kinder"] = 70] = "EE_Kinder";
    TherapyType[TherapyType["EE_Technik"] = 71] = "EE_Technik";
    TherapyType[TherapyType["Wachkoma"] = 72] = "Wachkoma";
    TherapyType[TherapyType["Inhalation_obere_Atemwege"] = 73] = "Inhalation_obere_Atemwege";
    TherapyType[TherapyType["Inhalation_unterer_Atemwege"] = 74] = "Inhalation_unterer_Atemwege";
    TherapyType[TherapyType["Absaugung_endotracheal"] = 75] = "Absaugung_endotracheal";
    TherapyType[TherapyType["ISK_FSK"] = 76] = "ISK_FSK";
    TherapyType[TherapyType["Anale_Irrigation"] = 77] = "Anale_Irrigation";
    TherapyType[TherapyType["Pessarversorgung"] = 78] = "Pessarversorgung";
    TherapyType[TherapyType["Medikamententherapie"] = 79] = "Medikamententherapie";
    TherapyType[TherapyType["Immunglobulintherapie"] = 80] = "Immunglobulintherapie";
    TherapyType[TherapyType["Laryngektomie"] = 81] = "Laryngektomie";
    TherapyType[TherapyType["Schmerztherapie_Pumpe_mobil"] = 82] = "Schmerztherapie_Pumpe_mobil";
    TherapyType[TherapyType["Haemophilie"] = 83] = "Haemophilie";
    TherapyType[TherapyType["Lungenhochdruck_PAH"] = 84] = "Lungenhochdruck_PAH";
    TherapyType[TherapyType["Movy"] = 85] = "Movy";
    TherapyType[TherapyType["Hizentra"] = 86] = "Hizentra";
    TherapyType[TherapyType["Schwerkraft_RH"] = 87] = "Schwerkraft_RH";
    TherapyType[TherapyType["Pumpe_mobil_RH"] = 88] = "Pumpe_mobil_RH";
    TherapyType[TherapyType["Tracheostoma"] = 89] = "Tracheostoma";
    TherapyType[TherapyType["Absaugung"] = 90] = "Absaugung";
    TherapyType[TherapyType["Beatmung_IV"] = 91] = "Beatmung_IV";
    TherapyType[TherapyType["Beatmung_NIV"] = 92] = "Beatmung_NIV";
    TherapyType[TherapyType["ASV"] = 93] = "ASV";
    TherapyType[TherapyType["Bilevel_Auto"] = 94] = "Bilevel_Auto";
    TherapyType[TherapyType["Bilevel_S"] = 95] = "Bilevel_S";
    TherapyType[TherapyType["AirMini"] = 96] = "AirMini";
    TherapyType[TherapyType["GOX"] = 97] = "GOX";
    TherapyType[TherapyType["Konzentrator_mobil"] = 98] = "Konzentrator_mobil";
    TherapyType[TherapyType["Konzentrator_stationaer"] = 99] = "Konzentrator_stationaer";
    TherapyType[TherapyType["LOX"] = 100] = "LOX";
    TherapyType[TherapyType["Befeuchtung"] = 101] = "Befeuchtung";
    TherapyType[TherapyType["High_Flow_HF"] = 102] = "High_Flow_HF";
    TherapyType[TherapyType["Hustenassistent"] = 103] = "Hustenassistent";
    TherapyType[TherapyType["Inhalation_AT"] = 104] = "Inhalation_AT";
    TherapyType[TherapyType["Kapnographie"] = 105] = "Kapnographie";
    TherapyType[TherapyType["Herz_Atem_Monitor"] = 106] = "Herz_Atem_Monitor";
    TherapyType[TherapyType["Pulsoximeter"] = 107] = "Pulsoximeter";
    TherapyType[TherapyType["Schlafdiagnostik"] = 108] = "Schlafdiagnostik";
    // "Zahnschiene" wurde historisch in "Verbrauchsmaterial Mitarbeiter" geändert
    // Der Enum Type wurde nicht geändert da hohes Risiko bei Migration/Schnittstellen
    // Der Therapy Type wird in den jeweiligen Frontends übersetzt #16046 #9542
    TherapyType[TherapyType["Zahnschiene"] = 109] = "Zahnschiene";
    TherapyType[TherapyType["O2_Flaschenversorgung"] = 110] = "O2_Flaschenversorgung";
    TherapyType[TherapyType["Sparsystem_mit_O2_Flasche"] = 111] = "Sparsystem_mit_O2_Flasche";
    TherapyType[TherapyType["ausgelagerte_Fertigung"] = 112] = "ausgelagerte_Fertigung";
    TherapyType[TherapyType["Selbstherstellung"] = 113] = "Selbstherstellung";
    TherapyType[TherapyType["Schienen"] = 114] = "Schienen";
    TherapyType[TherapyType["Kompressionsstruempfe"] = 115] = "Kompressionsstruempfe";
    TherapyType[TherapyType["Bandagen"] = 116] = "Bandagen";
    TherapyType[TherapyType["Oberschenkel_Prothese"] = 117] = "Oberschenkel_Prothese";
    TherapyType[TherapyType["Unterschenkel_Prothese"] = 118] = "Unterschenkel_Prothese";
    TherapyType[TherapyType["Sonstiges_ORTHO"] = 119] = "Sonstiges_ORTHO";
    TherapyType[TherapyType["Standard_REHA"] = 120] = "Standard_REHA";
    TherapyType[TherapyType["Schwerlast"] = 121] = "Schwerlast";
    TherapyType[TherapyType["Anti_Dekubitus_REHA"] = 122] = "Anti_Dekubitus_REHA";
    TherapyType[TherapyType["Rollstuhl_elektrisch"] = 123] = "Rollstuhl_elektrisch";
    TherapyType[TherapyType["Sonderbau_REHA"] = 124] = "Sonderbau_REHA";
    TherapyType[TherapyType["TENS"] = 125] = "TENS";
    TherapyType[TherapyType["EMS"] = 126] = "EMS";
    TherapyType[TherapyType["TENS_EMS"] = 127] = "TENS_EMS";
    TherapyType[TherapyType["Ulcus"] = 128] = "Ulcus";
    TherapyType[TherapyType["EE_Kinder_Sonde"] = 129] = "EE_Kinder_Sonde";
    TherapyType[TherapyType["EE_Kinder_Trink"] = 130] = "EE_Kinder_Trink";
    TherapyType[TherapyType["Diabetesversorgung"] = 131] = "Diabetesversorgung";
    TherapyType[TherapyType["Endotracheal"] = 132] = "Endotracheal";
    TherapyType[TherapyType["Parenterale_Ernaehrung"] = 133] = "Parenterale_Ernaehrung";
    TherapyType[TherapyType["Enterale_Ernaehrung"] = 134] = "Enterale_Ernaehrung";
    TherapyType[TherapyType["IV_Therapie"] = 135] = "IV_Therapie";
    TherapyType[TherapyType["OSA_IUA"] = 136] = "OSA_IUA";
    TherapyType[TherapyType["Hustenhilfen_IUA"] = 137] = "Hustenhilfen_IUA";
    TherapyType[TherapyType["Sauerstoff_IUA"] = 138] = "Sauerstoff_IUA";
    TherapyType[TherapyType["Beatmung_IUA"] = 139] = "Beatmung_IUA";
    TherapyType[TherapyType["Monitoring_MEADEV"] = 140] = "Monitoring_MEADEV";
    TherapyType[TherapyType["Pulsoximetrie_MEADEV"] = 141] = "Pulsoximetrie_MEADEV";
    TherapyType[TherapyType["Fingerpulsoximetrie_MEADEV"] = 142] = "Fingerpulsoximetrie_MEADEV";
    TherapyType[TherapyType["Kapnometer_MEADEV"] = 143] = "Kapnometer_MEADEV";
    TherapyType[TherapyType["Blutdruckmessgeraet_MEADEV"] = 144] = "Blutdruckmessgeraet_MEADEV";
    TherapyType[TherapyType["Babyueberwachung_MEADEV"] = 145] = "Babyueberwachung_MEADEV";
    TherapyType[TherapyType["Chronische_Wunde"] = 146] = "Chronische_Wunde";
    TherapyType[TherapyType["Fixierung_WV"] = 147] = "Fixierung_WV";
    TherapyType[TherapyType["Desinfektion_WV"] = 148] = "Desinfektion_WV";
    TherapyType[TherapyType["Pumpe_PE"] = 149] = "Pumpe_PE";
    TherapyType[TherapyType["Pumpe_RH"] = 150] = "Pumpe_RH";
    TherapyType[TherapyType["Pumpe_EE"] = 151] = "Pumpe_EE";
    TherapyType[TherapyType["Iv_PCA"] = 152] = "Iv_PCA";
    TherapyType[TherapyType["Sc_PCA"] = 153] = "Sc_PCA";
    TherapyType[TherapyType["PAH_AMG"] = 154] = "PAH_AMG";
    TherapyType[TherapyType["Immunglobuline"] = 155] = "Immunglobuline";
    TherapyType[TherapyType["Antiinfektivagabe"] = 156] = "Antiinfektivagabe";
    TherapyType[TherapyType["Lecigon"] = 157] = "Lecigon";
    TherapyType[TherapyType["Sonstiges_AMG"] = 158] = "Sonstiges_AMG";
    TherapyType[TherapyType["Kombi_STA_MOB"] = 159] = "Kombi_STA_MOB";
    TherapyType[TherapyType["Pumpe_immobil_K4"] = 160] = "Pumpe_immobil_K4";
    TherapyType[TherapyType["EE_Verband"] = 161] = "EE_Verband";
    TherapyType[TherapyType["HPE_Dreikammerbeutel"] = 162] = "HPE_Dreikammerbeutel";
    TherapyType[TherapyType["Infusiontherapie"] = 163] = "Infusiontherapie";
    TherapyType[TherapyType["Direktverkauf"] = 164] = "Direktverkauf";
    TherapyType[TherapyType["Atemtrainer"] = 165] = "Atemtrainer";
    TherapyType[TherapyType["Fertig_PE"] = 166] = "Fertig_PE";
    TherapyType[TherapyType["Enzymersatztherapie_IV"] = 167] = "Enzymersatztherapie_IV";
    TherapyType[TherapyType["Oral_SON"] = 168] = "Oral_SON";
    TherapyType[TherapyType["Subkutan_SON"] = 169] = "Subkutan_SON";
    TherapyType[TherapyType["HPE_Dreikammerbeutel_PE"] = 170] = "HPE_Dreikammerbeutel_PE";
    TherapyType[TherapyType["Fluessigkeitszufuhr_IV"] = 171] = "Fluessigkeitszufuhr_IV";
    TherapyType[TherapyType["Subkutan_Infusion_IV"] = 172] = "Subkutan_Infusion_IV";
    TherapyType[TherapyType["Hautablederung_WV"] = 173] = "Hautablederung_WV";
    TherapyType[TherapyType["Wundnaht_pri_WV"] = 174] = "Wundnaht_pri_WV";
    TherapyType[TherapyType["Wundnaht_sek_WV"] = 175] = "Wundnaht_sek_WV";
    TherapyType[TherapyType["Tumor_WV"] = 176] = "Tumor_WV";
    TherapyType[TherapyType["IAD_WV"] = 177] = "IAD_WV";
    TherapyType[TherapyType["Sonstiges_PE"] = 178] = "Sonstiges_PE";
    TherapyType[TherapyType["Sonstiges_EE"] = 179] = "Sonstiges_EE";
    TherapyType[TherapyType["Schwerkraft_SI"] = 180] = "Schwerkraft_SI";
    TherapyType[TherapyType["Pumpe_immobil_SI"] = 181] = "Pumpe_immobil_SI";
    TherapyType[TherapyType["Pumpe_mobil_SI"] = 182] = "Pumpe_mobil_SI";
    TherapyType[TherapyType["Sonstiges_SI"] = 183] = "Sonstiges_SI";
    TherapyType[TherapyType["Sonstiges_STO"] = 184] = "Sonstiges_STO";
    TherapyType[TherapyType["Sonstiges_TS"] = 185] = "Sonstiges_TS";
    TherapyType[TherapyType["Katheter_suprapubisch_INKO"] = 186] = "Katheter_suprapubisch_INKO";
    TherapyType[TherapyType["Katheter_transurethral_INKO"] = 187] = "Katheter_transurethral_INKO";
    TherapyType[TherapyType["Kondomurinale_INKO"] = 188] = "Kondomurinale_INKO";
    TherapyType[TherapyType["Katheterwechsel_INKO"] = 189] = "Katheterwechsel_INKO";
    TherapyType[TherapyType["Sonstiges_INKO"] = 190] = "Sonstiges_INKO";
    TherapyType[TherapyType["Trinknahrung_klassisch_TN"] = 191] = "Trinknahrung_klassisch_TN";
    TherapyType[TherapyType["Dialyse_TN"] = 192] = "Dialyse_TN";
    TherapyType[TherapyType["Sonstiges_TN"] = 193] = "Sonstiges_TN";
    TherapyType[TherapyType["Serviceleistungen_SL"] = 194] = "Serviceleistungen_SL";
    TherapyType[TherapyType["Sonstige_Absaugung_ABS"] = 195] = "Sonstige_Absaugung_ABS";
    TherapyType[TherapyType["Konzentrator_SS"] = 196] = "Konzentrator_SS";
    TherapyType[TherapyType["Sonstiges_SS"] = 197] = "Sonstiges_SS";
    TherapyType[TherapyType["Rollstuhlsitzkissen_LHM"] = 198] = "Rollstuhlsitzkissen_LHM";
    TherapyType[TherapyType["Sonstiges_LHM"] = 199] = "Sonstiges_LHM";
    TherapyType[TherapyType["Fingerpulsoximeter_MT"] = 200] = "Fingerpulsoximeter_MT";
    TherapyType[TherapyType["Blutdruckmessger\u00E4te_MT"] = 201] = "Blutdruckmessger\u00E4te_MT";
    TherapyType[TherapyType["Sonstiges_MT"] = 202] = "Sonstiges_MT";
    TherapyType[TherapyType["Sonstiges_SON"] = 203] = "Sonstiges_SON";
    TherapyType[TherapyType["Pumpe_Sapphire_PE"] = 204] = "Pumpe_Sapphire_PE";
    TherapyType[TherapyType["Pumpe_Bodyguard_PE"] = 205] = "Pumpe_Bodyguard_PE";
    TherapyType[TherapyType["Pumpe_Cadd_Solis_Vip_PE"] = 206] = "Pumpe_Cadd_Solis_Vip_PE";
    TherapyType[TherapyType["Trinknahrung_Erw_TNO"] = 207] = "Trinknahrung_Erw_TNO";
    TherapyType[TherapyType["Trinknahrung_Kinder_TNO"] = 208] = "Trinknahrung_Kinder_TNO";
    TherapyType[TherapyType["Pumpe_Sapphire_ST"] = 209] = "Pumpe_Sapphire_ST";
    TherapyType[TherapyType["Pumpe_Cadd_Solis_Vip_ST"] = 210] = "Pumpe_Cadd_Solis_Vip_ST";
    TherapyType[TherapyType["Schwerkraft_ST"] = 211] = "Schwerkraft_ST";
    TherapyType[TherapyType["Sonstiges_ST"] = 212] = "Sonstiges_ST";
    TherapyType[TherapyType["Tracheostoma_geblockt_unbeatmet"] = 213] = "Tracheostoma_geblockt_unbeatmet";
    TherapyType[TherapyType["Tracheostoma_geblockt_beatmet"] = 214] = "Tracheostoma_geblockt_beatmet";
    TherapyType[TherapyType["Tracheostoma_ungeblockt_unbeatmet"] = 215] = "Tracheostoma_ungeblockt_unbeatmet";
    TherapyType[TherapyType["Tracheostoma_ungeblockt_beatmet"] = 216] = "Tracheostoma_ungeblockt_beatmet";
    TherapyType[TherapyType["Stuhlinko_transanale_Irrigation_INKO"] = 217] = "Stuhlinko_transanale_Irrigation_INKO";
    TherapyType[TherapyType["Blasenverweilkatheter_INKO"] = 218] = "Blasenverweilkatheter_INKO";
    TherapyType[TherapyType["Urinalkondomversorgung_INKO"] = 219] = "Urinalkondomversorgung_INKO";
    TherapyType[TherapyType["Nierenfistel_links_INKO"] = 220] = "Nierenfistel_links_INKO";
    TherapyType[TherapyType["Nierenfistel_rechts_INKO"] = 221] = "Nierenfistel_rechts_INKO";
    TherapyType[TherapyType["WV_allgemein"] = 222] = "WV_allgemein";
    TherapyType[TherapyType["Vakuum_therapie_WV"] = 223] = "Vakuum_therapie_WV";
    TherapyType[TherapyType["Compounding_IV"] = 224] = "Compounding_IV";
    TherapyType[TherapyType["Wundheilungsstoerung_postop_WV"] = 225] = "Wundheilungsstoerung_postop_WV";
    TherapyType[TherapyType["Verbrennung_WV"] = 226] = "Verbrennung_WV";
    TherapyType[TherapyType["Einstichstelle_WV"] = 227] = "Einstichstelle_WV";
    TherapyType[TherapyType["Hauttransplantat_WV"] = 228] = "Hauttransplantat_WV";
    TherapyType[TherapyType["OP_Wunde_WV"] = 229] = "OP_Wunde_WV";
    TherapyType[TherapyType["Wunde_traumatisch_WV"] = 230] = "Wunde_traumatisch_WV";
    TherapyType[TherapyType["Wunde_Tumor_WV"] = 231] = "Wunde_Tumor_WV";
    TherapyType[TherapyType["Ulcus_cruris_arteriosum_WV"] = 232] = "Ulcus_cruris_arteriosum_WV";
    TherapyType[TherapyType["Ulcus_cruris_venosum_WV"] = 233] = "Ulcus_cruris_venosum_WV";
    TherapyType[TherapyType["Ulcus_cruris_mixtum_WV"] = 234] = "Ulcus_cruris_mixtum_WV";
    TherapyType[TherapyType["Ulcus_unklar"] = 235] = "Ulcus_unklar";
    TherapyType[TherapyType["Werbemittel_SON"] = 236] = "Werbemittel_SON";
    TherapyType[TherapyType["Nahrung_EE"] = 237] = "Nahrung_EE";
    TherapyType[TherapyType["Ableitungssystem_SON"] = 238] = "Ableitungssystem_SON";
    TherapyType[TherapyType["Bodyguard_ST"] = 239] = "Bodyguard_ST";
    TherapyType[TherapyType["Elastomare_Einmalpumpe_RH"] = 240] = "Elastomare_Einmalpumpe_RH";
    TherapyType[TherapyType["Bia_Messgeraet_MEADEV"] = 241] = "Bia_Messgeraet_MEADEV";
    TherapyType[TherapyType["Inkontinenz_ableitend_immobil_INKO"] = 242] = "Inkontinenz_ableitend_immobil_INKO";
    TherapyType[TherapyType["Inkontinenz_ableitend_mobil_INKO"] = 243] = "Inkontinenz_ableitend_mobil_INKO";
    TherapyType[TherapyType["Biofeedbackgeraete_15_INKO"] = 244] = "Biofeedbackgeraete_15_INKO";
    TherapyType[TherapyType["Pleural_Drainage_ASEPT"] = 245] = "Pleural_Drainage_ASEPT";
    TherapyType[TherapyType["Aszites_Drainage_ASEPT"] = 246] = "Aszites_Drainage_ASEPT";
    TherapyType[TherapyType["Blinatumonap_AKT"] = 247] = "Blinatumonap_AKT";
    TherapyType[TherapyType["Exulzerierte_Tumore_WV"] = 248] = "Exulzerierte_Tumore_WV";
    TherapyType[TherapyType["Podologische_Versorgung_WV"] = 249] = "Podologische_Versorgung_WV";
    TherapyType[TherapyType["Sekundaer_heilende_Wunde_WV"] = 250] = "Sekundaer_heilende_Wunde_WV";
    TherapyType[TherapyType["Podologische_Versorgung_SON"] = 251] = "Podologische_Versorgung_SON";
    TherapyType[TherapyType["Parenterale_Ernaehrung_PE"] = 252] = "Parenterale_Ernaehrung_PE";
    TherapyType[TherapyType["Schmerztherapie_ST"] = 253] = "Schmerztherapie_ST";
    TherapyType[TherapyType["Rehydration_RH"] = 254] = "Rehydration_RH";
    TherapyType[TherapyType["Sondennahrung_EE"] = 255] = "Sondennahrung_EE";
})(TherapyType = exports.TherapyType || (exports.TherapyType = {}));
exports.default = TherapyType;
